import {
  FileUploadToastContent,
  UPLOAD_TOAST_ID,
} from '@/components/Ingest/FileUploadToastContent';
import { useAuth } from '@/context/AuthContext';
import { uploadingFilesAtom } from '@/store/fileUploadStore';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { toast } from 'sonner';

export function useUploadToast() {
  const uploadingFiles = useAtomValue(uploadingFilesAtom);
  const { userLoading, user } = useAuth();
  const leftoverFiles = uploadingFiles?.some(
    (f) =>
      (f.status === 'IN_PROGRESS' ||
        f.status === 'TIMEOUT' ||
        f.status === 'FAILED') &&
      f.chatbotId,
  );

  useEffect(() => {
    if (uploadingFiles === undefined || userLoading || !user) {
      return;
    }

    if (leftoverFiles) {
      toast.custom((t) => <FileUploadToastContent toastId={t} />, {
        id: UPLOAD_TOAST_ID,
        duration: Number.POSITIVE_INFINITY,
        dismissible: false,
        position: 'bottom-left',
        className: '!px-0 !py-0 bg-popover border-border !rounded-xl',
      });
    }
  }, [uploadingFiles, userLoading, user]);
}
